import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Button from "./Button";

/**
 * Canonical confirm/delete dialog — modal-button DS reference.
 * Presentational only (no API). Prefer this pattern for new delete confirms.
 */
const ConfirmDeleteModal = ({
  isOpen = false,
  title = "Suppression",
  message = "Voulez-vous vraiment supprimer cet élément ?",
  confirmLabel = "Supprimer",
  cancelLabel = "Annuler",
  onConfirm,
  onCancel,
}) => (
  <Modal
    isOpen={isOpen}
    toggle={onCancel}
    centered
    className="confirm-delete-modal"
    modalClassName="confirm-delete-modal-root"
  >
    <ModalHeader toggle={onCancel}>{title}</ModalHeader>
    <ModalBody>
      <p style={{ margin: 0, color: "#5e5e5e", fontWeight: 500 }}>{message}</p>
    </ModalBody>
    <ModalFooter>
      <Button variant="secondary" onClick={onCancel}>
        {cancelLabel}
      </Button>
      <Button variant="danger" onClick={onConfirm}>
        {confirmLabel}
      </Button>
    </ModalFooter>
  </Modal>
);

export default ConfirmDeleteModal;
